<template>
  <el-card
    class="background"
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div class="contract-list">
      <SiruiSearch
        ref="searchRef"
        :query="queryData"
        :columns="topColumns"
        :isQueryPanel="true"
        @resetBtnClick="resetBtnClick"
        @changeMethod="changeMethod"
        @searchBtnClick="searchBtnClick"
      ></SiruiSearch>
      <div class="main-table">
        <sirui-table
          ref="siruiTable"
          :buttonList="menuButtonList"
          :loading="loading"
          :data="tableData"
          :paging="true"
          :setting="false"
          :customVisible="true"
          :columns="tableColumns"
          @chooseClick="chooseClick"
          @handleSelectionChange="handleSelectionChange"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          @dblclickEvent="dblclickEvent"
        >
          <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
          <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in tableColumns"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <template v-slot="{ row }">
              <span v-if="item.field == 'contractStatus'">{{
                getName('contractStatus', row[item.field])
              }}</span>
              <span v-else-if="item.field == 'contractType'">{{
                getName('contractType', row[item.field])
              }}</span>
              <span v-else-if="item.field == 'contractTitle'">{{
                getName('contractTitle', row[item.field])
              }}</span>
              <span v-else-if="item.field == 'contractPenaltyTypeCode'">{{
                getName('contractPenaltyTypeCode', row[item.field])
              }}</span>
              <span v-else-if="item.field == 'applyDepartment'">{{ row.departmentName }}</span>
              <span v-else>{{ row[item.field] }}</span>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
      <DeleteContractDialog
        ref="deleteContractRef"
        @operateSuccess="resetBtnClick"
        :deleteIds="deleteIds"
      ></DeleteContractDialog>
      <DeleteApprovalDialog
        ref="deleteApprovalRef"
        @operateSuccess="resetBtnClick"
        :deleteIds="deleteIds"
      ></DeleteApprovalDialog>
    </div>
  </el-card>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import { searchColumns } from './columns/searchColumns';
  import { defaultTableColumns } from './index.js';
  import tableBtnMixin from './tableBtnMixin';
  import DeleteContractDialog from './components/deleteContractDialog.vue';
  import DeleteApprovalDialog from './components/deleteApprovalDialog.vue';
  import API from '@/api/purchaseSalesCenter/outerServiceContract.js';
  import BASE_API from '@/api/dataBase';
  export default {
    name: 'serviceContractList',
    mixins: [tableBtnMixin],
    data() {
      return {
        loading: false,
        tableColumns: [],
        queryData: {
          contractCode: null,
          contractName: null,
          projectName: null,
          supplierName: null,
          applyDepartment: null,
          contractStatus: null,
          contractType: null,
        },
        menuButtonList: [], // 表格功能按钮
        tableData: [], // 表格数据
        multipleSelection: [],
        selectedItems: [],
        serviceContractType: [], // 合同类别
        serviceContractStatus: [], // 单据状态
        contractTitleList: [], //合同类别
        contractPenaltyTypeList: [], //违约金类型
        deleteIds: [],
        departmentList: [],
      };
    },
    computed: {
      topColumns() {
        return searchColumns(this);
      },
    },
    mounted() {
      // this.queryData.applyDepartment = this.userInfo.departmentCode;
      this.getButtonList();
      this.getTableData();
      this._getDepartmentByCompanyCodeApi();
      this.serviceContractType = this.dictListMap.serviceContractType;
      this.serviceContractStatus = this.dictListMap.serviceContractStatus;
      this.contractTitleList = this.dictListMap.serviceContractTitleType;
      this.contractPenaltyTypeList = this.dictListMap.liquidatedDamages;
    },
    methods: {
      // 获取菜单按钮
      async getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      // 获取当前列数据
      getColumnInfo() {
        this.getColumnList(defaultTableColumns).then(() => {
          this.tableColumns = defaultTableColumns;
        });
      },
      // 搜索
      searchBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.idList = [];
        this.getTableData();
      },
      // 重置
      resetBtnClick() {
        console.log('重置');
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.idList = [];
        this.queryData.applyDepartment = this.userInfo.departmentCode;
        this.getTableData();
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
      // 获取表格数据
      async getTableData() {
        this.isLoading = true;
        const postData = {
          ...this.queryData,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
        };
        console.log(postData, 'postData');
        const { data } = await this.$axios.post(API.LIST_CONTRACT_BY_PAGE, postData);
        console.log(data, '123');
        this.isLoading = false;
        if (data.code == 0) {
          this.$refs.siruiTable.setPageTotal(data.data.total);
          this.tableData = data.data.records;
        } else {
          this.$message.error('查询表格数据失败');
          this.tableData = [];
        }
      },

      // 选中触发事件
      handleSelectionChange(row) {
        this.multipleSelection = row;
        console.log(row);
      },
      // 替换显示表格中value为label
      getName(type, value) {
        if (value == null || value == undefined || value == '') {
          return '';
        }
        let item;
        if (type == 'contractType') {
          if (!this.serviceContractType.length || this.serviceContractType == undefined) {
            return value;
          }
          item = this.serviceContractType.find((item) => item.value == value);
          return item.label;
        } else if (type == 'contractStatus') {
          if (!this.serviceContractStatus.length || this.serviceContractStatus == undefined) {
            return value;
          }
          item = this.serviceContractStatus.find((item) => item.value == value);
          return item.label;
        } else if (type == 'contractTitle') {
          if (!this.contractTitleList.length || this.contractTitleList == undefined) {
            return value;
          }
          if (value == null || value == undefined || value == '') {
            return;
          }
          item = this.contractTitleList.find((item) => item.value == value);
          return item.label;
        } else if (type == 'contractPenaltyTypeCode') {
          if (!this.contractPenaltyTypeList.length) {
            return value;
          }
          item = this.contractPenaltyTypeList.find((item) => item.value == value);
          return item.label;
        }
      },
      // 表单改变事件
      changeMethod(row) {
        if (row.prop == 'projectName') {
          this.queryData.projectName = row.val[0].projectName;
        } else if (row.prop == 'supplierName') {
          this.queryData.supplierName = row.val[0].partnerZhName;
          console.log(row, '供应商名称');
        } else if (row.prop == 'applyDepartment') {
          console.log(row, '申请部门名称');
        }
      },
      // 根据公司获取部门
      async _getDepartmentByCompanyCodeApi() {
        const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: this.userInfo.companyCode,
        });
        if (data.code == 0) {
          this.departmentList = data.data?.personDepartmentInfo.map((item) => {
            return {
              label: item.personDepartmentName,
              value: item.personDepartmentCode,
            };
          });
        } else {
          console.error('获取部门失败');
        }
      },
      // 双击行事件
      dblclickEvent({ row }) {
        const path = {
          path: 'salePurchase/serviceContractDetail',
          name: 'serviceContractDetail',
          meta: {
            keepAlive: false,
            title: '',
          },
          query: {
            contractCode: row.contractCode,
            status: 'detail',
            contractStatus: row.contractStatus,
            id: row.id,
          },
        };
        this.$router.push(path);
      },
    },
    components: {
      SiruiSearch,
      DeleteContractDialog,
      DeleteApprovalDialog,
    },
  };
</script>

<style lang="scss" scoped></style>
